import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { GenericLinkModule, HamburgerMenuModule, KeyboardFocusModule } from '@spartacus/storefront';
import { LoginModule } from '@spartacus/user/account/components';
import { SearchBoxModule } from '../search-box/search-box.module';
import { HeaderLinksOutletComponent } from './header-links/header-links.component';

@NgModule({
  declarations: [HeaderLinksOutletComponent],
  imports: [
    CommonModule,
    RouterModule,
    LoginModule,
    I18nModule,
    SearchBoxModule,
    KeyboardFocusModule,
    GenericLinkModule,
    HamburgerMenuModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SearchBoxComponent: {
          component: HeaderLinksOutletComponent,
        },
      },
    } as CmsConfig),
  ],
})
export class HeaderLinksModule {}
